import React, { useState } from "react";
import { fmtUsd, CASE_THUMBS, optimize } from "../../data/casesData";
import { Info, Package, Flame, Sparkles, Loader2, Star } from "lucide-react";

const badgeStyle = {
  HOT: { label: "HOT", color: "#FB7185", bg: "rgba(251,113,133,0.16)", Icon: Flame },
  NEW: { label: "NEW", color: "#34D399", bg: "rgba(52,211,153,0.16)", Icon: Sparkles },
  LIMITED: { label: "LIMITED", color: "#FBBF24", bg: "rgba(251,191,36,0.16)", Icon: Star },
};

export default function CaseCard({ c, onOpen, onOdds }) {
  const b = badgeStyle[c.badge];
  const [imgErr, setImgErr] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const category = (c.tagline || "").split("·")[0].trim();

  return (
    <div
      data-testid="case-card"
      data-case-id={c.id}
      className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-[var(--uc-border)] bg-[var(--uc-card)] p-4 transition-all duration-300 hover:-translate-y-1 hover:border-[var(--uc-border-active)] hover:bg-[var(--uc-card-hover)] hover:shadow-xl hover:shadow-purple-900/20"
    >
      {b && (
        <div className="absolute left-3 top-3 z-10 flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-black uppercase tracking-wider"
          style={{ background: b.bg, color: b.color }}>
          <b.Icon className="h-3 w-3" /> {b.label}
        </div>
      )}
      <button onClick={(e) => { e.stopPropagation(); onOdds(c); }} data-testid="case-info-btn"
        className="absolute right-3 top-3 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/5 text-[var(--uc-muted)] transition-colors hover:bg-white/10 hover:text-white">
        <Info className="h-3.5 w-3.5" />
      </button>

      <div
        onClick={() => onOpen(c)}
        className="relative flex aspect-[5/4] cursor-pointer items-center justify-center overflow-hidden rounded-xl"
        style={{ background: `radial-gradient(70% 70% at 50% 40%, ${c.accent}2e 0%, transparent 70%)` }}
      >
        {!imgErr ? (
          <>
            {!imgLoaded && <Loader2 className="absolute h-7 w-7 animate-spin text-white/30" />}
            <img src={optimize(CASE_THUMBS[c.id], 640)} alt={c.name} onError={() => setImgErr(true)} onLoad={() => setImgLoaded(true)} loading="lazy" decoding="async"
              className={`h-[90%] w-[90%] object-contain drop-shadow-[0_14px_26px_rgba(0,0,0,0.55)] transition-[opacity,transform] duration-300 group-hover:scale-[1.06] ${imgLoaded ? "opacity-100" : "opacity-0"}`} />
          </>
        ) : (
          <Package className="h-16 w-16" style={{ color: c.accent }} />
        )}
      </div>

      <div className="mt-3 flex flex-1 flex-col">
        <div className="font-cases text-[14px] font-normal uppercase leading-tight tracking-tight text-white line-clamp-1">{c.name}</div>
        <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
          {category && (
            <span className="rounded-full bg-white/5 px-2 py-0.5 text-[10px] font-semibold text-[var(--uc-muted)]">{category}</span>
          )}
          <span className="rounded-full bg-white/5 px-2 py-0.5 text-[10px] font-semibold text-[var(--uc-muted)]">{c.opens.toLocaleString()} opened</span>
        </div>

        <div className="mt-3 flex items-center gap-2">
          <button
            data-testid="case-card-open-button"
            onClick={() => onOpen(c)}
            className="flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-gradient-to-r from-[#8B5CF6] to-[#6D28D9] px-3 py-2.5 text-sm font-bold text-white shadow-lg shadow-purple-900/30 transition-all hover:from-[#7C3AED] hover:to-[#5B21B6]"
          >
            Open <span className="font-grotesk">{fmtUsd(c.price)}</span>
          </button>
          <button
            data-testid="case-card-info-button"
            onClick={(e) => { e.stopPropagation(); onOdds(c); }}
            className="flex h-[42px] items-center justify-center rounded-xl border border-white/10 px-3 text-sm font-semibold text-[var(--uc-muted)] transition-colors hover:border-white/30 hover:text-white"
          >
            <Info className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
